<template>
    <div>
        <div class="w-full flex justify-between border-b-gray-500 text-gray-500 tracking-widest">
            <div>
                State
            </div>
            <div><span class="text-3xl text-yellow-600" v-if="hasUnsavedChanges">•</span></div>
        </div>
        <div v-if="isEditable" class="flex justify-between items-center pl-2">
            <input @change="updateState" type="text" v-model="state" class="border p-1 m-1 w-full">
        </div>
        <div class="pl-2" v-else>
            <div class="p-1">
                {{ calculatedState }}
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, computed, watch } from 'vue';

const props = defineProps([
    'company',
    'isEditable'
])

const emit = defineEmits(['update-state'])

const calculatedState = computed(() => {
    if(props.company) {
        return props.company.state
    } else {
        return null
    }
})

const state = ref(props.company ? props.company.state : null)

watch(calculatedState, () => {
    state.value = calculatedState.value
})

const hasUnsavedChanges = computed(() => {
    return props.company && props.company.original_state != props.company.state
})

function updateState(){
    emit('update-state', state.value)
}


</script>